import React from 'react'

const ResourceCenter = () => {
  return <div>ResourceCenter</div>
}

export default ResourceCenter
